// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListItem_wrapper__1uWFV","image-covered":"ListItem_image-covered__2v7RL","title":"ListItem_title__12_nC","date":"ListItem_date__2zraA"};